import { Outlet } from "react-router-dom";
import { SessionTimeoutHandler } from "./components/SessionTimeoutHandler";

function AppLayout() {
  return (
    <>
      <SessionTimeoutHandler />
      <Outlet />
    </>
  );
}

export default AppLayout;
